export enum DiseaseSearchType {
  breed,
  name,
  cause,
}
